<div class="container-fluid feed-wrapper d-flex flex-column">
  <div class="row pt-2 px-3 pb-1 header-row">
    <div class="col-6">
      <h3 class="feed-title text-white">Theatre Cases Live Feed</h3>
    </div>
    <div class="col-6 text-end text-white">
      <div class="d-inline-flex">
        <h3>{{ today | date:'yyyy-MM-dd HH:mm' }}</h3>
      </div>
      <button type="button" class="btn-close ms-2" aria-label="Close" (click)="closeFeed()"></button>
    </div>
  </div>
  <div class="feed-body flex-fill d-flex flex-column">
    <div class="row feed-headers feed-row feed-row-h pb-3">
      <div class="col cell">Scheduled Time</div>
      <div class="col cell">Case Type</div>
      <div class="col cell">Theatre</div>
      <div class="col-2 cell">Lead Practitioner</div>
      <div class="col cell">Case Code</div>
      <div class="col-3 cell">Procedure(s)</div>
      <div class="col cell">Status</div>
      <div class="col cell">Procedure Time</div>
    </div>
    <div class="flex-fill d-flex" id="content-wrapper">
      <div #feedWrapper class="row flex-fill" id="row-wrapper">
        <div #feedRows [ngStyle]="{ 'margin-top': displayOffset + 'px' }" class="col-12" id="rows">
          <div [ngClass]="{ 'multiblock': caseGroup.length > 1 }" id="block-{{blockIndex}}" class="group-block"
               *ngFor="let caseGroup of displayCases; let blockIndex = index">
            <div class="row feed-row feed-row-item pt-2 pb-2" *ngFor="let case of caseGroup; let i = index">
              <div class="col cell">
                {{ case.scheduled_time_start | date:'HH:mm' }} - {{
                case.scheduled_time_end |
                date:'HH:mm' }}</div>
              <div class="col cell">
                <span class="case-type {{ case.case_type }}">{{ case.case_type | titlecase }}</span>
              </div>
              <div class="col cell text-truncate">
                {{ case.theatre_name }}</div>
              <div class="col-2 cell text-truncate">
                {{ case.specialist_title | noData: '' }}
                {{ case.specialist_first_name ? case.specialist_first_name[0] : '' }}
                {{ case.specialist_last_name | noData: '' }}
                <br>
                {{ case.specialty }}
              </div>
              <div class="col cell">
                {{ case.case_code }}</div>
              <div class="col-3 cell wrapline">
                {{ case.scheduled_procedures }}
              </div>
              <div class="col cell">
                <span class="case-status {{ case.status }} text-nowrap">
                  {{ case.status | underscoreToTitle }}</span>
              </div>
              <div class="col cell">
                {{ case.procedure_time | date:'HH:mm' | noData: 'N/A' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="arrow-wrapper">
        <div class="arrow"></div>
      </div>
    </div>
  </div>
</div>